export default "__VITE_ASSET__b9b54ed8__"